/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { PjErrorInfo } from '../../extends_fw/service/PjErrorInfo';
import { PjBaseService } from '../../extends_fw/service/PjBaseService';
import { PjServiceResponse } from '../../extends_fw/service/PjServiceResponse';
import { UserApi } from '../api/UserApi';
import { LoginResult } from '../dto/LoginResult';
import { User } from '../model/User';
import { PostUserRes } from '../model/PostUserRes';
import { GetUserRes } from '../model/GetUserRes';
import { GetUserstateRes } from '../model/GetUserstateRes';

/**
 * ユーザの認証情報を管理する。
 */
export class AuthenticationService extends PjBaseService {

    /**
     * ユーザ情報
     */
    protected user: User;

    /**
     * コンストラクタ
     * @param {ng.IQService} $q 非同期サービス
     * @param {UserApi} userApi ユーザ認証API
     */
    /* @ngInject */
    public constructor(
            protected $q: ng.IQService,
            protected userApi: UserApi) {
        super(null);
    }

    /**
     * ログイン
     * @param {string} userId ユーザID
     * @param {string} password パスワード
     * @return {ng.IPromise<PjServiceResponse<LoginResult>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、ログインの認証結果となる。
     */
    public login(
            userId: string,
            password: string): ng.IPromise<PjServiceResponse<LoginResult>> {
        let deferred: ng.IDeferred<PjServiceResponse<LoginResult>> = this.$q.defer();
        this.userApi
            .userPost(userId, password)
            .success((data: PostUserRes, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig): void => {

                // ユーザの情報をsessionStorageへ格納する(共通ヘッダで表示するため)
                if (data.result) {
                    this.user = data.user;
                }
                let result: LoginResult = {
                    result: data.result,
                    user: this.user
                };

                // 必要があればレスポンスデータの加工を実施
                deferred.resolve({ status: status, data: result });
            })
            .error((data: PjErrorInfo, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig): void => {
                deferred.reject({ status: status, error: data });
            });
        return deferred.promise;
    }

    /**
     * ユーザ情報取得
     * @return {ng.IPromise<PjServiceResponse<User>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、ユーザ情報となる。
     */
    public getUser(): ng.IPromise<PjServiceResponse<User>> {
        let deferred: ng.IDeferred<PjServiceResponse<User>> = this.$q.defer();
        if (!this.user) {

            // キャッシュに格納されていなければ取得する
            // 同時にアクセスにきたことを考慮し、2重送信チェックを追加
            this.userApi
                .userGet(true)
                .success((data: GetUserRes, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {

                    // 取得できた場合、ユーザの情報を格納
                    if (data) {
                       this.user = data.user;
                       deferred.resolve({ status: status, data: this.user });
                    }
                })
                .error((data: PjErrorInfo, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                    deferred.reject({ status: status, error: data });
                });

        } else {

            // キャッシュから返す
            deferred.resolve({ status: 200, data: this.user });
        }
        return deferred.promise;
    }

    /**
     * 認証状態チェック
     * @return {ng.IPromise<PjServiceResponse<boolean>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、ユーザの認証状態(true:認証済み/false：未認証）となる。
     */
    public isAuthenticated(): ng.IPromise<PjServiceResponse<boolean>> {
        let deferred: ng.IDeferred<PjServiceResponse<boolean>> = this.$q.defer();
        this.userApi
            .userStateGet(true)
            .success((data: GetUserstateRes, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {

                // ユーザの情報をsessionStorageへ格納する(共通ヘッダで表示するため)
                deferred.resolve({ status: status, data: data.result });
            })
            .error((data: PjErrorInfo, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                deferred.reject({ status: status, error: data });
            });
        return deferred.promise;
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/authentication/service/AuthenticationService.ts
 **/